import {css} from 'styled-components';

export const darkNoRedGreenThemeColors = css`
  --browser-color-scheme: dark;
  --color-keyline-default: var(--color-translucent-gray20);
  --color-link-default: var(--color-core-blue200);
  --color-link-hover: var(--color-core-blue400);
  --color-link-disabled: var(--color-core-gray750);
  --color-text-default: var(--color-core-white);
  --color-text-light: var(--color-core-gray300);
  --color-text-lighter: var(--color-core-gray500);
  --color-text-disabled: var(--color-core-gray600);
  --color-text-red: var(--color-core-yellow200);
  --color-text-yellow: var(--color-core-yellow200);
  --color-text-green: var(--color-core-cobalt200);
  --color-text-blue: var(--color-core-blue200);
  --color-text-olive: var(--color-core-olive200);
  --color-text-cyan: var(--color-core-cyan200);
  --color-text-lime: var(--color-core-lime200);
  --color-background-default: var(--color-core-gray990);
  --color-background-default-hover: var(--color-core-gray950);
  --color-background-light: var(--color-core-gray950);
  --color-background-light-hover: var(--color-core-gray900);
  --color-background-lighter: var(--color-core-gray850);
  --color-background-lighter-hover: var(--color-core-gray800);
  --color-background-disabled: var(--color-core-gray800);
  --color-background-red: var(--color-translucent-yellow15);
  --color-background-red-hover: var(--color-translucent-yellow20);
  --color-background-yellow: var(--color-translucent-yellow15);
  --color-background-yellow-hover: var(--color-translucent-yellow20);
  --color-background-green: var(--color-translucent-cobalt15);
  --color-background-green-hover: var(--color-translucent-cobalt20);
  --color-background-blue: var(--color-translucent-gray15);
  --color-background-blue-hover: var(--color-translucent-gray20);
  --color-background-olive: var(--color-translucent-olive15);
  --color-background-oliver-hover: var(--color-translucent-olive20);
  --color-background-cyan: var(--color-translucent-cyan15);
  --color-background-cyan-hover: var(--color-translucent-cyan20);
  --color-background-lime: var(--color-translucent-lime15);
  --color-background-lime-hover: var(--color-translucent-lime20);
  --color-background-gray: var(--color-translucent-gray15);
  --color-background-gray-hover: var(--color-translucent-gray20);
  --color-border-default: var(--color-core-gray800);
  --color-border-hover: var(--color-core-gray700);
  --color-border-disabled: var(--color-core-gray600);
  --color-focus-ring: var(--color-core-white);
  --color-accent-primary: var(--color-core-gray150);
  --color-accent-primary-hover: var(--color-core-gray50);
  --color-accent-reversed: var(--color-core-gray950);
  --color-accent-reversed-hover: var(--color-core-gray800);
  --color-accent-red: var(--color-core-yellow500);
  --color-accent-red-hover: var(--color-core-yellow600);
  --color-accent-yellow: var(--color-core-yellow700);
  --color-accent-yellow-hover: var(--color-core-yellow600);
  --color-accent-green: var(--color-core-cobalt400);
  --color-accent-green-hover: var(--color-core-cobalt500);
  --color-accent-blue: var(--color-core-gray600);
  --color-accent-blue-hover: var(--color-core-gray500);
  --color-accent-cyan: var(--color-core-cyan500);
  --color-accent-cyan-hover: var(--color-core-cyan600);
  --color-accent-lime: var(--color-core-lime500);
  --color-accent-lime-hover: var(--color-core-lime600);
  --color-accent-lavender: var(--color-core-blue800);
  --color-accent-lavender-hover: var(--color-core-blue700);
  --color-accent-olive: var(--color-core-olive500);
  --color-accent-olive-hover: var(--color-core-olive600);
  --color-accent-gray: var(--color-core-gray500);
  --color-accent-gray-hover: var(--color-core-gray600);
  --color-accent-white: var(--color-core-gray150);
  --color-always-white: var(--color-core-white);
  --color-dialog-background: var(--color-translucent-gray90);
  --color-tooltip-background: var(--color-core-gray850);
  --color-tooltip-text: var(--color-core-white);
  --color-popover-background: var(--color-core-gray900);
  --color-popover-background-hover: var(--color-core-gray850);
  --color-shadow-default: var(--color-translucent-gray90);
  --color-nav-background: var(--color-core-gray990);
  --color-nav-text: var(--color-core-gray400);
  --color-nav-text-hover: var(--color-core-gray300);
  --color-nav-text-selected: var(--color-core-white);
  --color-nav-button: var(--color-core-gray900);
  --color-nav-button-hover: var(--color-core-gray850);
  --color-lineage-edge: var(--color-core-gray850);
  --color-lineage-edge-highlighted: var(--color-core-gray500);
  --color-lineage-group-node-background: var(--color-core-gray900);
  --color-lineage-group-node-background-hover: var(--color-core-gray850);
  --color-lineage-group-node-border: var(--color-core-gray700);
  --color-lineage-group-node-border-hover: var(--color-core-gray400);
  --color-lineage-group-background: var(--color-translucent-dark-wash);
  --color-lineage-node-background: var(--color-core-gray850);
  --color-lineage-node-background-hover: var(--color-core-gray800);
  --color-lineage-node-border: var(--color-core-gray700);
  --color-lineage-node-border-hover: var(--color-core-gray400);
  --color-lineage-node-border-selected: var(--color-core-white);
  --color-data-viz-blue: var(--color-dataviz-blue200);
  --color-data-viz-blue-alt: var(--color-dataviz-blue100);
  --color-data-viz-blurple: var(--color-dataviz-blurple200);
  --color-data-viz-blurple-alt: var(--color-dataviz-blurple100);
  --color-data-viz-brown: var(--color-dataviz-brown200);
  --color-data-viz-brown-alt: var(--color-dataviz-brown100);
  --color-data-viz-cyan: var(--color-dataviz-cyan200);
  --color-data-viz-cyan-alt: var(--color-dataviz-cyan100);
  --color-data-viz-gray: var(--color-dataviz-gray200);
  --color-data-viz-gray-alt: var(--color-dataviz-gray100);
  --color-data-viz-green: var(--color-core-cobalt200);
  --color-data-viz-green-alt: var(--color-core-cobalt100);
  --color-data-viz-lime: var(--color-dataviz-lime200);
  --color-data-viz-lime-alt: var(--color-dataviz-lime100);
  --color-data-viz-orange: var(--color-dataviz-orange200);
  --color-data-viz-orange-alt: var(--color-dataviz-orange100);
  --color-data-viz-pink: var(--color-dataviz-pink200);
  --color-data-viz-pink-alt: var(--color-dataviz-pink100);
  --color-data-viz-red: var(--color-dataviz-yellow300);
  --color-data-viz-red-alt: var(--color-dataviz-yellow200);
  --color-data-viz-teal: var(--color-dataviz-teal200);
  --color-data-viz-teal-alt: var(--color-dataviz-teal100);
  --color-data-viz-violet: var(--color-dataviz-violet200);
  --color-data-viz-violet-alt: var(--color-dataviz-violet100);
  --color-data-viz-yellow: var(--color-dataviz-yellow200);
  --color-data-viz-yellow-alt: var(--color-dataviz-yellow100);
  --color-checkbox-unchecked: var(--color-core-gray500);
  --color-checkbox-checked: var(--color-core-cobalt500);
  --color-checkbox-disabled: var(--color-core-gray700);
  --color-blue-gradient: linear-gradient(
    var(--color-core-gray950),
    var(--color-translucent-blue15) 100%
  );
`;
